var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{staticClass:"benefits-toggle-control"},[_c('input',{staticClass:"benefits-toggle-input",attrs:{"disabled":_vm.disabled,"aria-label":_vm.ariaLabel,"type":"checkbox"},domProps:{"checked":_vm.value},on:{"change":function($event){return _vm.$emit('input', $event.target.checked)}}}),_vm._v(" "),_c('span',{staticClass:"benefits-toggle"})])
}
var staticRenderFns = []

export { render, staticRenderFns }